import React, { Component } from 'react';
import { Spinner } from '../Spinner';
import s from './Loader.scss';

class Loader extends Component {
  render() {
    return (
      <div className={s.loader} data-hook="pa-spinner">
        <div>
          <Spinner />
        </div>
      </div>
    );
  }
}

export default Loader;
